import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import compose from "recompose/compose";
import {connect} from "react-redux";

import {
	updEditableTableValue
} from "../../../../actions/components";




const styles = {
	tableTextInput:{
		fontSize:'0.875rem'
	}
};

const getChecked = (value) =>{
	if(!value) return false;
	return Boolean(value === 1);
}
const getValue = (checked) =>{
	return checked ? 1 : 0;
}

class checkBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checked : getChecked(props.value),
		};
	}
	handleOnChange = () =>{
		this.setState({
			checked:!this.state.checked
		})
		const {dispatch, id, name} = this.props;
		dispatch(updEditableTableValue({
			id,
			name,
			value:getValue(!this.state.checked)
		}))
	}


	render() {
		const {disabled, name, id} = this.props;

		const objectName = name + "_" + id;
		return (
			<Checkbox
				name={objectName}
				checked={this.state.checked}
				onChange={this.handleOnChange}
				inputProps={{
					'aria-label': 'primary checkbox'
				}}
				disabled={disabled}
			/>
		);
	}
}

checkBox.propTypes = {
	value : PropTypes.number,
	disabled : PropTypes.bool,

	id : PropTypes.string.isRequired,
	name : PropTypes.string.isRequired

};
checkBox.defaultProps = {
	disabled : false,
}
const mapStateToProps = state => {
	return {
		tableState : state.componentsEditableTableState,
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(checkBox);



// WEBPACK FOOTER //
// ./src/common/components/table/input/check-box.js